/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const UpdateEmailContentTypeDto = {
    CakeInstallationAgencies: 'CAKE_INSTALLATION_AGENCIES',
    CakeInstallationCompanies: 'CAKE_INSTALLATION_COMPANIES',
    ChristmasOffer: 'CHRISTMAS_OFFER',
    Custom: 'CUSTOM',
    DecisionQuestionRequest: 'DECISION_QUESTION_REQUEST',
    General: 'GENERAL',
    GrazingTable: 'GRAZING_TABLE',
    OpinionRequest: 'OPINION_REQUEST',
    PostEventFollowUp: 'POST_EVENT_FOLLOW_UP',
    ResponseAsSoonAsPossible: 'RESPONSE_AS_SOON_AS_POSSIBLE',
    ResponseAsSoonAsPossibleWithRequestVerification: 'RESPONSE_AS_SOON_AS_POSSIBLE_WITH_REQUEST_VERIFICATION',
    SendingOffer: 'SENDING_OFFER',
    SixFloorTheatre: 'SIX_FLOOR_THEATRE',
    SixFloorTheatreOpenDay: 'SIX_FLOOR_THEATRE_OPEN_DAY',
    ForumEventCompanies: 'FORUM_EVENT_COMPANIES',
    FatThursday: 'FAT_THURSDAY',
    OpenDayFoksal: 'OPEN_DAY_FOKSAL',
    Easter2026: 'EASTER_2026',
} as const;

export type UpdateEmailContentTypeDto = typeof UpdateEmailContentTypeDto[keyof typeof UpdateEmailContentTypeDto];



